// extracted by mini-css-extract-plugin
export var articleeventcardcomponent = "ArticleOrEventCard-module--articleeventcardcomponent--324d9";
export var articleeventcarddetails = "ArticleOrEventCard-module--articleeventcarddetails--cdc6d";
export var articleeventcardimage = "ArticleOrEventCard-module--articleeventcardimage--fc831";
export var articleeventcardtitle = "ArticleOrEventCard-module--articleeventcardtitle--bd026";
export var cardlink = "ArticleOrEventCard-module--cardlink--1e90a";
export var noorphan = "ArticleOrEventCard-module--noorphan--52598";